<template>
  <div>
    <summary-table />
  </div>
</template>
<script>
import SummaryTable from "@/components/summaryTable/SummaryTable";
import store from '@/store';
import NProgress from 'nprogress';
export default {
  components: {
    SummaryTable
  },
  beforeRouteEnter(to, from, next) {
    NProgress.start();
    store.dispatch('getAllDzo', to.params.id).then(response => {
      NProgress.done();
      next();
    });
  },
}
</script>
